export function useLocationPicker() {

    const isLocationPickerOpen = useState('isLocationPickerOpen', () => false)
    const isLocationUpdateOpen = useState('isLocationUpdateOpen', () => false)
    const isLocationChangeOpen  = useState('isLocationChangeOpen', () => false)
    const currentLocationCoord = useState<{ latitude: number; longitude: number } | null>('currentLocationCoord', () => null)

    const openLocationPicker = () => {
        isLocationPickerOpen.value = true
    }

    const closeLocationPicker = () => {
        isLocationPickerOpen.value = false
    }

    const handleLocationSuccess = (data: any) => {
        isLocationPickerOpen.value = false
    }

    const openLocationUpdate = () => {
        isLocationUpdateOpen.value = true
    }

    const closeLocationUpdate = () => { 
        isLocationUpdateOpen.value = false
    }

    const handleLocationUpdateSuccess = (data: any) => {
        isLocationUpdateOpen.value = false
    }

    const openLocationChangePopup = () => {
        isLocationChangeOpen.value = true
    }

    const closeLocationChangePopup = () => { 
        isLocationChangeOpen.value = false
    }


    return {
        isLocationPickerOpen,
        openLocationPicker,
        closeLocationPicker,
        handleLocationSuccess,
        isLocationUpdateOpen,
        openLocationUpdate,
        closeLocationUpdate,
        handleLocationUpdateSuccess,
        isLocationChangeOpen,
        currentLocationCoord,
        openLocationChangePopup,
        closeLocationChangePopup,
    }
}
